export { default } from "./selectors";



// WEBPACK FOOTER //
// ./src/model/subsystems/app/selectors/index.js